<template>
  <VDialog id="dialog" v-model="show" persistent max-width="1000px">
    <VForm ref="formVDialog">
      <LoadingDialog ref="Loading"/>
      <VCard class="pa-1">
        <VCardTitle class="title">Assinatura presencial</VCardTitle>
        <VCardText>
          <VContainer ma-0 pa-1>
            <div id="signatario">
              <iframe id="assinaturapresencial" style="width:100%;height:350px;border: 0px;allow: geolocation" :src="registro.linkAssinaturaPresencial"></iframe>
            </div>
          </VContainer>
        </VCardText>
        <VCardActions>
          <VBtn @click="fechar" block :disabled="requisicaoEmAndamento">Fechar</VBtn>
        </VCardActions>
      </VCard>
    </VForm>
  </VDialog>
</template>
<script>
import LoadingDialog from '@/components/Dialog/Loading.vue';
import jQuery from "jquery";

window.jQuery = jQuery;
window.$ = jQuery;

export default {
  name: "AssinaturaPresencial",
  components: {LoadingDialog},
  props: ['visible', 'item'],
  computed: {
    show: {
      get(){
        return this.visible
      },
      set(value){
        if(!value){
          this.$emit('close')
        }
      }
    },
    registro: {
      get(){
        return this.item
      },
      set(value){
        this.item = value
      }
    },
  },
  data() {
    return this.dadosIniciais()
  },
  methods: {
    dadosIniciais() {
      return {
        requisicaoEmAndamento: false,
        visivel: false,
        // signatario: {
        //   id: null,
        //   nome: null,
        //   email: null,
        //   isPresencial: false,
        //   acao: {
        //     id: 1,
        //     acao: 'Assinar'
        //   },
        //   assinado: false,
        //   linkAssinaturaPresencial: "",
        //   chave: ""
        // }
      }
    },
    async abrir() {
      this.show = true;
    },
    async fechar() {
      this.$emit('close');
    },
    async enviarEAguardarBackend(promises, texto) {
      try {
        this.requisicaoEmAndamento = true;
        return await this.$refs.Loading.aguardarPromises(promises, texto);
      } finally {
        this.requisicaoEmAndamento = false;
      }
    }
  },
  watch: {
    async show(value){
      if(value){
        await this.abrir()
      }
    }
  },
}
</script>

<style scoped>

</style>
